module.exports = __webpack_public_path__ + "static/media/bold.a221248b.svg";